import { getAllInSession } from '@cldf/scotiaweb-customer-information';
import { getInStorage, saveInStorage } from '@cldf/scotiaweb-web-storage';
import { getMercurySettings } from '../../../../../services/service.parameters';
import { getSimpleAccountDetails } from '../../../../../services';

export const getSession = async (setMercuryEnabled, setMercuryApi, setMercuryRenderersUrl) => {
  const session = await getAllInSession();

  const { mercuryApiUrl, mercuryRenderersUrl } = await getMercurySettings();
  setMercuryEnabled(session.TGLMER !== undefined);
  setMercuryApi(mercuryApiUrl);
  setMercuryRenderersUrl(mercuryRenderersUrl);
};

export const callSimpleAccountService = async (
  accountNumber,
  currentLocalStorageInformation = null,
  setSimpleAccountNumber,
  setIsRedClient
) => {
  let newSimpleAccount = currentLocalStorageInformation;
  await getSimpleAccountDetails(accountNumber)
    .then(response => {
      newSimpleAccount = {
        ...newSimpleAccount,
        ...{
          [accountNumber]: {
            currentSimpleAccount: response.data.currentSimpleAccount,
            originalAccountNumber: response.data.originalAccountNumber,
          },
        },
      };
      setSimpleAccountNumber(newSimpleAccount);
      setIsRedClient(false);
      saveInStorage(CLIENT_ACCOUNTS, newSimpleAccount);
    })
    .catch(error => {
      if (error.response.status !== 200) {
        setIsRedClient(true);
      }
    });
};

export const getSimpleAccount = async (accountNumber, setSimpleAccountNumber, simpleAccountNumber, setIsRedClient) => {
  const CLIENT_ACCOUNTS = 'simple_accounts';
  const CLIENT_COLOR = 'client_color';

  if (!simpleAccountNumber) {
    const simpleAccountsInLS = await getInStorage(CLIENT_ACCOUNTS);
    /* istanbul ignore else */
    if (simpleAccountsInLS) {
      setIsRedClient(false);
      if (!simpleAccountsInLS[accountNumber]) {
        callSimpleAccountService(accountNumber, simpleAccountsInLS, setSimpleAccountNumber, setIsRedClient);
      } else {
        setSimpleAccountNumber(simpleAccountsInLS);
      }
    } else {
      const clientColor = await getInStorage(CLIENT_COLOR);
      if (!clientColor || clientColor !== 'RED') {
        callSimpleAccountService(accountNumber, simpleAccountsInLS, setSimpleAccountNumber, setIsRedClient);
      } else {
        setIsRedClient(true);
      }
    }
  } else {
    setIsRedClient(false);
    if (!simpleAccountNumber[accountNumber]) {
      callSimpleAccountService(accountNumber, simpleAccountNumber, setSimpleAccountNumber, setIsRedClient);
    }
  }
};
